import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { smoothlyMenu } from '@app/app.helpers';
import { CommonService } from '@app/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { MainComponent } from '../main/main.component';
import swal from 'sweetalert2';

declare var jQuery: any;

@Component({
    selector: 'app-topnavbar',
    templateUrl: './topnavbar.component.html'
})

export class TopnavbarComponent {
    constructor(public translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent, public commonService: CommonService) { }

    ngOnInit(): void {

    }

    toggleNavigation(): void {
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }

    changeLang(lang: string) {
        if (this.router.url == '/login') {
            this.setLanguage(lang);
        } else {
            this.translate.get(['CONFIRM_TO_CHANGE_LANGUAGE',
                'CONFIRM',
                'CANCEL'])
                .subscribe(res => {
                    swal.fire({
                        text: res.CONFIRM_TO_CHANGE_LANGUAGE,
                        type: 'warning',
                        showCancelButton: true,
                        cancelButtonText: res.CANCEL,
                        confirmButtonText: res.CONFIRM
                    }).then(result => {
                        if (result.value) {
                            // handle confirm
                            this.setLanguage(lang);
                            this.router.navigate([this.router.url])
                            // window.location.reload();
                        } else {
                            // handle dismiss, result.dismiss can be 'cancel', 'overlay', 'close', and 'timer'
                        }
                    });
                });
        }

    }

    setLanguage(lang: string) {
        this.translate.use(lang);
        this.commonService.setDefaultLang(lang);
    }

}
